import { render, staticRenderFns } from "./CreateWeetAnnotationMode.vue?vue&type=template&id=4b9f9f70&scoped=true"
import script from "./CreateWeetAnnotationMode.vue?vue&type=script&lang=ts"
export * from "./CreateWeetAnnotationMode.vue?vue&type=script&lang=ts"
import style0 from "./CreateWeetAnnotationMode.vue?vue&type=style&index=0&id=4b9f9f70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f9f70",
  null
  
)

export default component.exports